import { createRecipeContext, type HTMLChakraProps, type RecipeProps, type UnstyledProp } from '@chakra-ui/react';
import * as React from 'react';

import { SpinnerArc } from './spinner-arc';
import type { SpinnerSize } from './spinner.kds';

export interface SpinnerProps
  extends Omit<HTMLChakraProps<'span'>, 'colorPalette'>, UnstyledProp, Omit<RecipeProps<'spinner'>, 'colorPalette'> {
  size?: SpinnerSize;
}

const { withContext } = createRecipeContext({ key: 'spinner' });
const SpinnerRoot = withContext('span') as React.ForwardRefExoticComponent<
  SpinnerProps & React.RefAttributes<HTMLSpanElement>
>;

export const Spinner = React.forwardRef<HTMLSpanElement, SpinnerProps>(function Spinner(props, ref) {
  return (
    <SpinnerRoot ref={ref} {...props}>
      <SpinnerArc />
    </SpinnerRoot>
  );
});
